import { render, staticRenderFns } from "./FilasTarefaDadosPage.vue?vue&type=template&id=94d64a34"
import script from "./FilasTarefaDadosPage.vue?vue&type=script&lang=js"
export * from "./FilasTarefaDadosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports